import Icon from '../components/Icon.vue'

Icon.register({"cloud-download-alt":{"width":640,"height":512,"paths":[{"d":"M537.6 226.6C541.7 215.9 544 204.2 544 192 544 139 501 96 448 96 428.3 96 409.9 102 394.7 112.2 367 64.2 315.3 32 256 32 167.6 32 96 103.6 96 192 96 194.7 96.1 197.4 96.2 200.1 40.2 219.8 0 273.2 0 336 0 415.5 64.5 480 144 480H512C582.7 480 640 422.7 640 352 640 290.1 596 238.4 537.6 226.6zM404.7 315.3L299.3 420.7C293.1 426.9 282.9 426.9 276.7 420.7L171.3 315.3C161.2 305.2 168.4 288 182.6 288H248V176C248 167.2 255.2 160 264 160H312C320.8 160 328 167.2 328 176V288H393.4C407.6 288 414.8 305.2 404.7 315.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cloud-download-alt.js
// module id = Q04k
// module chunks = 0